module.exports = __webpack_public_path__ + "img/machaon-butterfly.eb85fccc.png";